import { useLocation } from 'react-router-dom';

export function ViewRegistration() {
  const location = useLocation();
  const registrationData = location.state?.data;

  return (
    <div className="max-w-4xl mx-auto mt-8 p-6 bg-white rounded-lg shadow">
      <h1 className="text-2xl font-bold text-center mb-6">Registration Details</h1>
      
      <div className="space-y-6">
        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-4">Customer Information</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-gray-50 rounded-lg">
            <p><strong>Name:</strong> {registrationData?.[0]?.customer_name}</p>
            <p><strong>Phone:</strong> {registrationData?.[0]?.phone}</p>
            <p><strong>Address:</strong> {registrationData?.[0]?.address}</p>
            <p><strong>Email:</strong> {registrationData?.[0]?.email}</p>
          </div>
        </div>

        <div>
          <h2 className="text-lg font-semibold mb-4">Share Details</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  <th className="py-3 px-4 border-b text-left">No.</th>
                  <th className="py-3 px-4 border-b text-left">Name</th>
                  <th className="py-3 px-4 border-b text-left">Type</th>
                  <th className="py-3 px-4 border-b text-left">Category</th>
                  <th className="py-3 px-4 border-b text-left">Slaughtering Day</th>
                  <th className="py-3 px-4 border-b text-left">Fisabilillah</th>
                </tr>
              </thead>
              <tbody>
                {registrationData?.map((share, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                    <td className="py-3 px-4 border-b">{index + 1}</td>
                    <td className="py-3 px-4 border-b">{share.firstname} {share.lastname}</td>
                    <td className="py-3 px-4 border-b">{share.type || 'N/A'}</td>
                    <td className="py-3 px-4 border-b">{share.category || 'N/A'}</td>
                    <td className="py-3 px-4 border-b">{share.slaughtering_day || 'N/A'}</td>
                    <td className="py-3 px-4 border-b">
                      {share.feasabilillah ? 
                        <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">Yes</span> : 
                        <span className="px-2 py-1 bg-gray-100 text-gray-800 rounded-full text-xs">No</span>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}